import type { Config, Output } from 'svgo';

type SvgoModule = {
    optimize: (input: string, config?: Config) => Output;
};

// Single promise handles loading and caching
let svgoPromise: Promise<SvgoModule> | null = null;

// svgo is a node library. It has a browser distribution that we lazy load
async function lazyLoadSvgo(): Promise<SvgoModule> {
    if (process.env.NODE_ENV === 'test') {
        throw Error('Module must be mocked in test environment');
    }

    if (!svgoPromise) {
        svgoPromise = import('svgo/browser');
    }

    return svgoPromise;
}

/**
 * SVG file may contain style sheet, this converts them to inline attributes
 */
export async function convertSvgStyleToAttrs(
    fileContent: string,
    fileName: string,
): Promise<File | undefined> {
    if (fileContent.indexOf('</svg>') === -1 && fileContent.indexOf('</style>') === -1) {
        return;
    }

    const svgo = await lazyLoadSvgo();
    const result = svgo.optimize(fileContent, {
        plugins: [
            { name: 'inlineStyles', params: { onlyMatchedOnce: false } },
            { name: 'convertStyleToAttrs' },
        ],
    });

    const blob = new Blob([result.data], { type: 'image/svg+xml' });
    return new File([blob], fileName, {
        type: 'image/svg+xml',
        lastModified: Date.now(),
    });
}
